import { useMessagesStore } from "@/stores/messages";

const WARNING_CODES = new Set([400, 403, 404, 409, 410, 429]);
const ERROR_CODES = new Set([500, 501]);

export const processErrors = (status, error) => {
    const messagesStore = useMessagesStore();

    // Check for authentication errors
    if (status === 401) {
        if (error.reason === "token is expired") {
            throw "go to login";
        }

        if (error.show) {
            messagesStore.msgError(error.reason || "Unauthorized");
        }
        throw error;
    }

    // Check for validation errors
    if (status === 422) {
        if (error.show) {
            messagesStore.msgWarning(error.reason || "Validation errors ocurred");
        }

        throw error;
    }

    // Check for warning errors
    if (WARNING_CODES.has(status)) {
        if (error.show) {
            messagesStore.msgWarning(error.reason || `${status} error`);
        }

        throw error;
    }

    // Check for server errors
    if (ERROR_CODES.has(status)) {
        if (error.show) {
            messagesStore.msgError(error.reason || `${status} error`);
        }

        throw error;
    }
};
